import React from 'react'

const CampStructure = () => {
  return (
    <div>
    <h1>how is this camp structured?</h1>
    <hr />
    <p>The neoG.camp is structured in three stages:</p>
    <h1>🐥 levelZero</h1>
    <hr />
    <ol>
        <li>Learn and build anytime (Free and open)
            <ul>
                <li>levelZero is the starting point of neoG.camp where you will learn the basics of programming in a structured fun manner. The levelZero was included in the camp later when we realized that there are students who wish to, but won’t be able to participate in levelOne because they have never written a single code line or are new to the #teamtanay community. Hence, levelZero will be your free entry and decider to the camp, where you will learn the basics while making fun-filled toy apps and host them online to share them with your friends and family and also decide whether you like programming or not. This self-paced course will serve as a filter for levelOne as the levelOne needs to be a small focussed group who really wish to advance in their career and get a (better) job.</li>
                <li>levelZero was added deliberately to enable the beginners to compete with intermediates at the same level as well as to make money (fees for levelOne) secondary and your will to work hard are the primary and main criteria for your success and getting you a job after the camp.</li>
            </ul>
        </li>
        <li>
            <ul>
                <li>Open classes on YouTube.</li>
                <li>Start your developer journey here and now.</li>
                <li>Free and open for everyone (beginners, intermediates, job-seekers from any field, and learners)</li>
                <li>A self-paced course on the basics of programming. Learn HTML, JS, CSS, Vanilla JS, React, and using Git and Github.</li>
                <li>Create your projects/apps with us and</li>
                <li>Submit those projects and assignments to apply for levelOne. You can read more about it here.</li>
                <p>The very basics, the ground level from where you start your programming journey will be covered at levelZero.</p>
            </ul>
        </li>
    </ol>

    {/* 🎓levelOne */}

    <h1>🎓levelOne</h1>
    <hr />
    <ol>
        <li>starts in Jan 2023 (closed and paid)
            <p>levelOne is the second and closed stage of the neoG.camp. It is a six-month boot camp for hard-working programmers of intermediate level (that you become after completing levelZero and qualifying for levelOne). This level is designed primarily to provide you with a focused closed group (your dedicated peer group) and to train you for an advanced level of programming. Every session for 6 months is drawn in a job-oriented way to increase your overall value as a programmer, train you on the market needs and get you prepared for job interviews</p>
            <ul>
                <li>Closed Live classes on Zoom.</li>
                <li>Learn industry-level coding and get a job.</li>
                <li>Open for the qualifiers. (Read more about it under “How to get into levelOne”.)</li>
                <li>six-month course for advanced-level job-oriented programming.</li>
                <li>guest lectures from industry experts.</li>
                <li>Closed Live classes on Zoom.</li>
                <li>Learn industry-level coding and get a job.</li>
                <li>Open for the qualifiers. (Read more about it under “How to get into levelOne”.)</li>
                <li>six-month course for advanced-level job-oriented programming.</li>
                <li>guest lectures from industry experts.</li>
            </ul>
        </li>
        <li>
            <ul>
                <li>Open classes on YouTube.</li>
                <li>Start your developer journey here and now.</li>
                <li>Free and open for everyone (beginners, intermediates, job-seekers from any field, and learners)</li>
                <li>A self-paced course on the basics of programming. Learn HTML, JS, CSS, Vanilla JS, React, and using Git and Github.</li>
                <li>Create your projects/apps with us and</li>
                <li>Submit those projects and assignments to apply for levelOne. You can read more about it here.</li>
                <p>The very basics, the ground level from where you start your programming journey will be covered at levelZero.</p>
            </ul>
        </li>
    </ol>

{/* 💰 placements */}

<h1>💰 placements</h1>
    <hr />
    <ol>
        <li>starts in May - June (for finalists and graduates of levelOne)
            <ul>
                <li>The last phase of the camp will entail job placements with our partner, roc8.careers. Once, you have completed the levelOne you will have advanced level projects, preparation for JS interviews, and an outstanding portfolio that can get you a job or a better package.</li>
                <li>For this process, we have partnered with roc8.careers (formerly known as JobChallege and ElevateLabs.tech).</li>
                <li>roc8.careers will groom you further for interviews, review your projects for individuality; and</li>
                <li>Then, you can interview through hiring partners and get a job!</li>
                <li>guest lectures from industry experts.</li>
                <li>Closed Live classes on Zoom.</li>
                <li>Learn industry-level coding and get a job.</li>
                <li>Open for the qualifiers. (Read more about it under “How to get into levelOne”.)</li>
                <li>six-month course for advanced-level job-oriented programming.</li>
                <li>guest lectures from industry experts.</li>
            </ul>
        </li>
        <li>
            <ul>
                <li>Open classes on YouTube.</li>
                <li>Start your developer journey here and now.</li>
                <li>Free and open for everyone (beginners, intermediates, job-seekers from any field, and learners)</li>
                <li>A self-paced course on the basics of programming. Learn HTML, JS, CSS, Vanilla JS, React, and using Git and Github.</li>
                <li>Create your projects/apps with us and</li>
                <li>Submit those projects and assignments to apply for levelOne. You can read more about it here.</li>
                <p>The very basics, the ground level from where you start your programming journey will be covered at levelZero.</p>
            </ul>
        </li>
    </ol>


</div>
  )
}

export default CampStructure